<div class="overlay" [hidden]="!displayAppUpdateDialogBox">
    <div class="center">
        <div class="alert-box" fxLayout="column" fxLayoutGap="1em">
            <div>Dostępna jest nowa wersja serwisu. <br />
                <span style="font-weight: 300">Wymagane jest ponowne wczytanie strony przez przeglądarkę!</span>
            </div>
            <!-- <button mat-flat-button color="accent" onclick="document.location.reload()">OK</button> -->
            <button mat-flat-button color="accent" (click)="reloadApp()">OK</button>
        </div>
    </div>
</div>